export default __webpack_public_path__ + "static/media/111_desktop.ad8c7377.jpg";